module.exports = __webpack_public_path__ + "static/media/DecNoticeDecline.9df12b3f.tsx";